/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IGroupCategoryModel } from '../../../../models/groups.model';
import { GroupsService } from '../../../../services/api/groups/groups.service';
import { LoaderService } from '../../../../services/loader/loader.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-category-popup',
    standalone: false,
    templateUrl: './category-popup.component.html',
    styleUrl: './category-popup.component.scss',
})
export class CategoryPopupComponent extends BasePopupComponent implements OnInit {
    protected groupCategoriesSignal = signal<IGroupCategoryModel[]>([]);
    protected selectedGroupCategories = signal<IGroupCategoryModel[]>([]);

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: any,
        protected override dialogRef: MatDialogRef<CategoryPopupComponent>,
        private dialog: MatDialog,
        private groupsService: GroupsService,
        private loaderService: LoaderService,
    ) {
        super(data, dialogRef);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.data?.selectedCategories) {
            this.selectedGroupCategories.set(this.data.selectedCategories);
        }
        this.loadGroupCategories();
    }

    protected confirmSelection(): void {
        this.dialogRef.close(this.selectedGroupCategories());
    }

    protected isCategorySelected(category: IGroupCategoryModel): boolean {
        return this.selectedGroupCategories().some((c) => c.id === category.id);
    }

    protected loadGroupCategories(keyword: string = ''): void {
        this.loaderService.show();
        this.groupsService.getGroupCategoryListing(999, keyword).subscribe({
            next: (response) => {
                const selected = this.selectedGroupCategories();
                const merged = [...response];
                for (const sel of selected) {
                    if (!merged.some((cat) => cat.id === sel.id)) {
                        merged.unshift(sel); // Add selected to front if not in response
                    }
                }
                this.groupCategoriesSignal.set(merged);
            },
            error: (error) => {
                const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                errorPopupConfig.data = {
                    title: `Error`,
                    message: error.error?.message,
                };
                this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                console.error('Error getting group categories', error);
            },
            complete: () => {
                this.loaderService.hide();
            },
        });
    }

    protected toggleCategory(category: IGroupCategoryModel): void {
        const current = [...this.selectedGroupCategories()];
        const index = current.findIndex((c) => c.id === category.id);

        if (index > -1) {
            current.splice(index, 1);
        } else {
            current.push(category);
        }

        this.selectedGroupCategories.set(current);
    }
}
